import PropTypes from 'prop-types';
import React from 'react';

const LazyImage = ({src, alt, id}) => (
  <img src={src} alt={alt} loading="lazy" data-machine-id={id} />
);

LazyImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  id: PropTypes.string
};

export default LazyImage;
